import { IconButton, UIHeading2, UIHeading4, UIText1, UIText3 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardLayout = {
  companionName?: string | null;
  companionTypeName: string;
  companionIdStr?: string;
  handleClickClose: () => void;
  avatar: React.ReactNode;
  actions: React.ReactNode | null;
  images: React.ReactNode | null;
  updateChatFiles: () => void;
};

export const UserCardLayout: React.VFC<TUserCardLayout> = ({
  companionName,
  companionTypeName,
  companionIdStr,
  handleClickClose,
  avatar,
  actions,
  images,
  updateChatFiles,
}) => {
  const scrollContainer = React.useRef<HTMLImageElement>(null);
  const [isVisibleFixedHeader, setVisibilityFixedHeader] = React.useState<boolean>(false);

  const handleScroll = React.useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;

      setVisibilityFixedHeader(scrollTop > 160);

      if (scrollHeight === scrollTop + offsetHeight) {
        updateChatFiles();
      }
    },
    [updateChatFiles],
  );

  return (
    <div className={styles['container']} data-testid="UserCardLayout">
      <div className={styles['header']}>
        {isVisibleFixedHeader && (
          <div className={styles['title__fixed']}>
            <div data-testid={'UserCardMobileLayoutName'}>
              <UIHeading4 color="text-primary-default">{companionName || companionIdStr}</UIHeading4>
            </div>
            <div data-testid={'UserCardMobileLayoutTypeName'}>
              <UIText3 color="gray60_100">{companionTypeName}</UIText3>
            </div>
          </div>
        )}
        <IconButton icon={<IconActionClose12 />} onClick={handleClickClose} data-testid="ButtonClose" />
      </div>
      <div className={styles['scroll']} onScroll={handleScroll} ref={scrollContainer}>
        {avatar}
        <div className={styles['title']}>
          <div data-testid={'UserCardMobileLayoutName'}>
            <UIHeading2 color="text-primary-default">{companionName || companionIdStr}</UIHeading2>
          </div>
          <div data-testid={'UserCardMobileLayoutTypeName'}>
            <UIText1 color="gray60_100">{companionTypeName}</UIText1>
          </div>
        </div>
        {actions}
        {images}
      </div>
    </div>
  );
};
